import { render } from "./SpeakerModule.html?vue&type=template&id=1034856a&scoped=true&external"
import script from "./SpeakerModule.vue?vue&type=script&lang=js"
export * from "./SpeakerModule.vue?vue&type=script&lang=js"

import "./SpeakerModule.vue?vue&type=style&index=0&id=1034856a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1034856a"]])

export default __exports__